import { useState, useEffect } from 'react'

type CopyFn = (text: string) => Promise<boolean> // Return success

export function useCopyToClipboard(): [boolean, CopyFn] {
  const [isCopied, setIsCopied] = useState(false)

  useEffect(() => {
    let isMounted = true

    if (isCopied) {
      const id = setTimeout(() => {
        if (isMounted) {
          setIsCopied(false)
        }
      }, 2000)

      return () => {
        isMounted = false
        clearTimeout(id)
      }
    }
  }, [isCopied])

  const copy: CopyFn = async (text) => {
    if (!navigator?.clipboard) {
      console.warn('Clipboard not supported')
      return false
    }

    try {
      await navigator.clipboard.writeText(text)
      setIsCopied(true)
      return true
    } catch (error) {
      console.warn('Copy failed', error)
      setIsCopied(false)
      return false
    }
  }

  return [isCopied, copy]
}
